const woerterSucheInput = document.getElementById('woertersuche') as HTMLInputElement | null;

if (woerterSucheInput !== null) {
  woerterSucheInput.addEventListener('input', (event: Event) => {
    const input = event.currentTarget as HTMLInputElement;
    const filter = input.value.toLowerCase();

    // Alle Zeilen im tbody der Tabelle holen
    const rows = document.querySelectorAll<HTMLTableRowElement>('.table.kategorie1 tbody tr');

    rows.forEach((row: HTMLTableRowElement) => {
      const text = row.innerText.toLowerCase();
      row.style.display = text.includes(filter) ? '' : 'none';
    });
  });
}